/* Opens the Complementary Products / Build Your Own panel by delegating to quick-add.js's
   quick-add-modal.show(opener); the opener carries data-product-url and .loading__spinner. */
(function () {
  if (window.complementaryPanelDelegated) return;
  window.complementaryPanelDelegated = true;

  document.addEventListener('click', function (event) {
    // Modified/middle clicks fall through so the card's normal <a href> still works.
    if (event.defaultPrevented) return;
    if (event.button && event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    // Build Your Own items (MUST-99) open the same panel.
    const opener = event.target.closest(
      '.complementary-products__item[data-product-url], .build-your-own__item[data-product-url]'
    );
    if (!opener) return;

    const modal = document.querySelector('quick-add-modal.cp-panel');
    if (!modal || typeof modal.show !== 'function') return;

    event.preventDefault();
    modal.show(opener);
  });
})();
